import script from "./PhotoGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoGallery.vue?vue&type=script&setup=true&lang=js"

import "./pageStyle.css?vue&type=style&index=0&id=f57d1b8a&scoped=true&lang=css&external"
import "./PhotoGallery.vue?vue&type=style&index=1&id=f57d1b8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f57d1b8a"]])

export default __exports__